import React from 'react';
import { graphql } from 'gatsby';
import ContentfulRowContent from 'components/Contentful/ContentfulRowContent';
import ContentfulLayout from 'components/Contentful/ContentfulLayout';
import ContentfulDynamicHero from 'components/Contentful/ContentfulDynamicHero';
import ComparisonCardSection from 'components/Page/Comparison/ComparisonCardSection';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';
import useComparisonCompanyCards from 'hooks/useComparisonCompanyCards';
import SEO, { createSEO } from 'components/Core/SEO';
import WebsiteLayout from 'layouts/websiteLayout';

const ComparisonPage = props => {
  const heroData = props.data.contentfulDynamicHero;
  const rowContentEdges = props.data.allContentfulRowContent.edges;
  const listSection = props.data.contentfulLayout;

  const seo = createSEO(props.data.contentfulSeo, props);
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  const cardInfo = useComparisonCompanyCards();

  return (
    <WebsiteLayout header={header} footer={footer} hero={heroData}>
      <SEO {...seo} />
      {heroData && <ContentfulDynamicHero {...heroData} />}
      <ContentfulLayout {...listSection} />
      <ContentfulRowContent {...rowContentEdges[2].node} />
      <ContentfulRowContent {...rowContentEdges[1].node} />
      <ContentfulRowContent {...rowContentEdges[0].node} />

      <ComparisonCardSection
        backgroundColor="#FFF"
        title="See How We Compare To The Competition"
        description="Find the right fit for your business"
        cardInfo={cardInfo}
      />
    </WebsiteLayout>
  );
};

export default ComparisonPage;

export const ComparisonPageQuery = graphql`
  query ComparisonPageQuery {
    contentfulSeo(internalName: { eq: "Comparison" }) {
      ...Seo
    }
    contentfulDynamicHero(contentful_id: { eq: "6cgYfIulOxX7q599nVJohd" }) {
      ...DynamicHero
    }
    contentfulLayout(internalName: { eq: "Comparison Page - Section 1" }) {
      ...Layout
    }
    allContentfulRowContent(
      filter: {
        internalName: {
          in: [
            "Comparison Page - Section 2"
            "Comparison Page - Section 3"
            "Comparison Page - Section 4"
          ]
        }
      }
    ) {
      edges {
        node {
          ...RowContent
        }
      }
    }
  }
`;
